import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message, Divider } from 'antd';
import { UserOutlined, LockOutlined, PhoneOutlined, WechatOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { authApi, wecomApi } from '../services/api';
import useAuthStore from '../store/authStore';

const { Title, Text } = Typography;

export default function Login() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const login = useAuthStore((s) => s.login);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await authApi.login(values);
      login(res.user, res.token, res.refreshToken);
      message.success(`欢迎回来，${res.user.name}！`);
      navigate('/');
    } catch (e) {
      if (e.code === 'ACCOUNT_LOCKED') {
        message.error(e.error);
      } else if (e.remainingAttempts !== undefined) {
        message.error(`账号或密码错误，剩余尝试次数：${e.remainingAttempts}`);
      } else {
        message.error(e?.error || '登录失败，请检查账号密码');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleWecomLogin = async () => {
    try {
      const res = await wecomApi.authUrl()
      window.location.href = res.url
    } catch (e) {
      message.error('获取企业微信授权链接失败')
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#f5f5f5',
    }}>
      <Card style={{ width: 380, borderRadius: 16, padding: '8px 8px' }} bordered={false}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 56, height: 56, borderRadius: 16, background: '#07c160',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px', fontSize: 28,
          }}>💼</div>
          <Title level={3} style={{ margin: 0 }}>微信CRM系统</Title>
          <Text type="secondary">销售团队客户管理平台</Text>
        </div>

        <Form onFinish={onFinish} layout="vertical" size="large">
          <Form.Item name="phone" rules={[{ required: true, message: '请输入手机号' }]}>
            <Input prefix={<PhoneOutlined />} placeholder="手机号" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="密码" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading}
              style={{ background: '#07c160', borderColor: '#07c160', height: 44, borderRadius: 8 }}>
              登录
            </Button>
          </Form.Item>
        </Form>

        <Divider>或</Divider>
        <Button icon={<WechatOutlined />} block onClick={handleWecomLogin}>
          企业微信登录
        </Button>

        <Text type="secondary" style={{ fontSize: 12 }}>
          演示账号：管理员 13800000000 / admin123，销售 13811111111 / sales123
        </Text>
      </Card>
    </div>
  );
}
